package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.entity.Driver
import com.milta.feature.team.domain.repository.TeamRepository

class LinkDriverUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(enterpriseId: String, code: String): Result<Driver> =
        repository.linkDriver(enterpriseId, code)
}
